import { useState, useEffect } from "react";

import { CustomOptionsHookConfig, CustomChoiceOption } from "../types";

const useCustomChoiceOptions = ({
  initialOptions,
  initialValue,
}: CustomOptionsHookConfig) => {
  const [areInitialValuesSet, setAreInitialValuesSet] = useState(false);
  const [customOptions, setCustomOptions] = useState<CustomChoiceOption[]>([]);

  useEffect(() => {
    if (initialOptions) {
      setCustomOptions([
        ...customOptions.filter((option) => option.custom),
        ...initialOptions,
      ]);
    }
  }, [initialOptions]);

  useEffect(() => {
    if (!areInitialValuesSet && initialValue) {
      setAreInitialValuesSet(true);

      const values = Array.isArray(initialValue)
        ? initialValue
        : [initialValue];
      const newOptions = [...customOptions];

      values.forEach((value) => {
        if (typeof value !== "string") return;

        const exists = customOptions.some((option) => option.value === value);

        if (!exists) {
          newOptions.push({ value, label: value, custom: true });
        }
      });

      if (newOptions.length !== customOptions.length) {
        setCustomOptions(newOptions);
      }
    }
  }, [initialOptions, areInitialValuesSet, initialValue]);

  return {
    customOptions,
    setCustomOptions,
  };
};

export default useCustomChoiceOptions;
